import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  linkedSignal,
  signal } from '@angular/core';
import { ResolvableModal} from '@softline/ui-core';

import { Employee } from '../../data/employee';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { search } from '@softline/core';

import { CheckboxComponent } from '@softline/ui-core';
import { IconComponent } from '@softline/ui-core';
import { InPipe } from '@softline/ui-core';
import { InputComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-worknote-select-employees-modal',
  templateUrl: './select-employees-modal.component.html',
  styleUrls: ['./select-employees-modal.component.css'],
  imports: [
    CheckboxComponent,
    IconComponent,
    InPipe,
    InputComponent,
    TranslatePipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush })
export class SelectEmployeesModalComponent extends ResolvableModal<Employee[] | null> {
  readonly allEmployees = input.required<Employee[]>(); // all available
  readonly employees = input.required<Employee[]>(); // selected

  protected readonly selectedEmployees = linkedSignal(() => this.employees());

  protected readonly selectedEmployeeIds = computed(() =>
    this.selectedEmployees().map((employee) => employee.id)
  );

  protected readonly isSaving = signal(false);

  readonly searchValue = signal<string | null>(null);

  readonly #debouncedSearchValue = toSignal(
    toObservable(this.searchValue).pipe(debounceTime(200), distinctUntilChanged())
  );

  readonly filteredEmployees = computed(() =>
    search(this.allEmployees(), this.#debouncedSearchValue() ?? '', {
      caseSensitive: false,
      wholeWord: false })
  );

  async save(): Promise<void> {
    this.resolve(this.selectedEmployees());
  }

  selectEmployee(employee: Employee): void {
    this.selectedEmployees.update((employees) => employees.concat(employee));
  }

  unselectEmployee(employee: Employee): void {
    this.selectedEmployees.update((employees) =>
      employees.filter((o) => o.id !== employee.id)
    );
  }
}
